module.exports = __webpack_public_path__ + "static/media/trimex_diez lustros.8c750f9c.png";